// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-card--link[data-v-bf06b36a]:before {\n    background: none;\n}\n", ""]);
// Exports
module.exports = exports;
